<template>
  <div class="order-details-content">
    <div
      v-for="(group, groupIndex) in orderItem.details.products"
      :key="groupIndex"
      class="order-details-content__group"
    >
      <div class="order-details-content__group__title">
        <BaseText size="p5">
          <span v-for="text in group.title" :key="text">{{ text }} </span>
        </BaseText>
      </div>
      <div
        v-for="(product, productIndex) in group.items"
        :key="productIndex"
        class="order-details-content__product"
        role="button"
        tabindex="0"
        @click="$emit('click', product)"
      >
        <div>
          <BaseText
            class="order-details-content__product__name"
            size="p5"
            :color="NebraskaColors.elementPrimary"
          >
            {{ product.name }}
          </BaseText>
          <ChipStatus
            v-if="product.status"
            class="order-details-content__product__icon"
            :status="statusMapper[product.status.type]"
            :label="product.status.label"
            :icon="product.status.icon"
          />
        </div>
        <div class="order-details-content__product__value">
          <BaseText size="p5" :color="NebraskaColors.elementPrimary">
            {{ product.value }}
          </BaseText>
          <BaseIcon icon="EA0170" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { BaseText, ChipStatus, BaseIcon } from '@warrenbrasil/nebraska-web';

import { IOrderItem } from '@/modules/wealth/services/portfolio-orders';

interface Props {
  orderItem: IOrderItem;
}

defineProps<Props>();

const statusMapper: { [key: string]: string } = {
  info: 'information',
  positive: 'positive',
  negative: 'negative',
  alert: 'alert'
};
</script>
<style lang="less" scoped>
.order-details-content {
  padding: @size-spacing-x800 @size-spacing-x1200;

  &__group {
    margin-bottom: @size-spacing-x800;

    &__title {
      margin-bottom: @size-spacing-x500;
      display: inline;
    }
  }

  &__product {
    padding: @size-spacing-x400 0;
    border-bottom: @size-border-x400 solid @divider-primary;
    display: flex;
    justify-content: space-between;
    cursor: pointer;

    &:first-of-type {
      padding: 0 0 @size-spacing-x500;
    }

    &:last-of-type {
      border-bottom: none;
    }

    &__name {
      margin-bottom: @size-spacing-x350;
    }

    &__icon {
      height: 26px;
    }

    &__value {
      display: flex;
      justify-content: center;
      gap: @size-spacing-x150;
    }
  }
}
</style>
